import { Component, HostListener, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IArea, IBoothColors, IDownloadAreaSettings } from '@sv/interfaces';
import { AreaAnalyticsService } from 'src/app/_services/_analytics/area-analytics.service';
import { TicketcodeAuthService } from 'src/app/_services/_auth/ticketcode-auth.service';

@Component({
  selector: 'app-download-area',
  templateUrl: './download-area.component.html',
  styleUrls: ['./download-area.component.scss'],
})
export class DownloadAreaComponent implements OnInit, OnDestroy {
  settings: IDownloadAreaSettings;
  primaryColor: string;
  secondaryColor: string;

  hovered: number;

  constructor(
    private areaAnalyticsService: AreaAnalyticsService,
    @Inject(MAT_DIALOG_DATA) public data: { area: IArea; settings: IDownloadAreaSettings; colors: IBoothColors },
    private dialogRef: MatDialogRef<DownloadAreaComponent>,
    private authService: TicketcodeAuthService
  ) {}
  mobile = false;

  @HostListener('window:resize', [])
  onResize() {
    const width = window.innerWidth;
    this.mobile = width < 699;
  }

  ngOnInit(): void {
    this.mobile = document.documentElement.clientWidth < 699;
    if (!this.data) {
      this.dialogRef.close();
    } else {
      this.settings = this.data.settings;
      if (this.data.colors) {
        this.primaryColor = this.data.colors.areaPrimary ?? '#92d050';
        this.secondaryColor = this.data.colors.areaSecondary ?? 'white';
      } else {
        this.primaryColor = '#92d050';
        this.secondaryColor = 'white';
      }
    }
  }

  pressedStyle() {
    return { 'background-color': this.secondaryColor, color: this.primaryColor };
  }

  buttonStyle() {
    return { 'background-color': this.primaryColor, color: this.secondaryColor };
  }

  downloadAll() {
    this.settings.downloads.forEach((download) => {
      const iframe = document.createElement('iframe');
      iframe.style.visibility = 'collapse';
      document.body.append(iframe);

      iframe.contentDocument.write(`<form action="${download.link.replace(/\"/g, '"')}" method="GET"></form>`);
      iframe.contentDocument.forms[0].submit();
      setTimeout(() => iframe.remove(), 2000);
    });
  }

  ngOnDestroy() {
    const url = window.location.href;
    if (!url.includes('cloudfront.net')) {
      if (localStorage.getItem('dataUsage') === 'true') {
        // this.areaAnalyticsService.newAreaView(this.data.area, this.authService.decodeToken()._id);
      } else {
        this.areaAnalyticsService.newAreaView(this.data.area);
      }
    }
  }
}
